import { styled } from 'styled-components';
import { Link } from 'react-router-dom';

export const CalendarPage = styled.div`
  padding: 20px;
  width: 100%;
  flex-basis: 100%;

  h2 {
    color: #2d3748;
  }
`;

export const CalendarNav = styled.div`
  margin-bottom: 20px;

  a {
    color: #4299e1;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const CalendarYearBlock = styled.div`
  display: inline-block;
  vertical-align: top;
  border: 2px solid #e2e8f0;
  padding: 15px;
  margin: 10px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
`;

export const CalendarYearTitle = styled.h3`
  color: #2d3748;
  margin-top: 0;
  font-size: 20px;
  font-weight: 600;
`;

export const CalendarMonthGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 80px);
  gap: 5px;
  margin-top: 10px;
`;

export const CalendarMonthCell = styled(Link)`
  color: #2d3748;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80px;
  border: 1px solid #e2e8f0;
  text-align: center;
  background-color: #ffffff;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f7fafc;
  }
`;

export const CalendarMonthCellEmpty = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80px;
  border: 1px solid #e2e8f0;
  text-align: center;
  color: #a0aec0;
  background-color: #f7fafc;
`;

export const CalendarMonthCount = styled.div`
  font-size: 11px;
`;

export const CalendarTable = styled.table`
  width: 100%;
  max-width: 800px;
  border-collapse: collapse;
  color: #2d3748;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);

  th {
    padding: 10px;
    border: 1px solid #e2e8f0;
    background-color: #f7fafc;
    font-weight: 600;
  }

  td {
    padding: 10px;
    border: 1px solid #e2e8f0;
    height: 80px;
    vertical-align: top;
    background-color: #ffffff;
  }
`;

export const CalendarDayLink = styled(Link)`
  color: #1a202c;
  text-decoration: underline;
  font-weight: 600;

  &:hover {
    color: #2d3748;
  }
`;

export const CalendarDayCount = styled.div`
  font-size: 12px;
`;

export const CalendarDayEmpty = styled.div`
  color: #a0aec0;
`;

export const CalendarDayImagesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  padding: 20px;
`;

export const CalendarDayHeader = styled.h2`
  color: #2d3748;
  margin: 10px 0 20px 0;
  font-weight: 600;
`;
